import { apiGet } from '@/services/api'
import type { ApiResponse } from './types'
import { debugError } from '@/utils/env'

// 平台信息接口（复用VIPPlatform结构）
export interface PlatformInfo {
  platform_id: number
  name: string
  code: string
  logo: string
  color: string
  description: string
}

/**
 * 获取所有平台列表
 */
export async function getPlatforms(): Promise<PlatformInfo[]> {
  try {
    const result = await apiGet<ApiResponse<PlatformInfo[]>>('/vip/platforms')

    if (result.errorcode === '0') {
      return result.data || []
    } else {
      throw new Error(result.errormsg || '获取平台列表失败')
    }
  } catch (error) {
    debugError('获取平台列表失败:', error)
    return []
  }
}

/**
 * 平台信息缓存
 */
let platformCache: PlatformInfo[] | null = null
let cacheTimestamp: number = 0
const CACHE_DURATION = 5 * 60 * 1000 // 5分钟缓存

/**
 * 获取平台列表（带缓存）
 */
export async function getPlatformsWithCache(): Promise<PlatformInfo[]> {
  const now = Date.now()

  if (platformCache && (now - cacheTimestamp) < CACHE_DURATION) {
    return platformCache
  }

  const platforms = await getPlatforms()
  platformCache = platforms
  cacheTimestamp = now

  return platforms
}

/**
 * 清除平台缓存
 */
export function clearPlatformCache(): void {
  platformCache = null
  cacheTimestamp = 0
}
